<template>
    <div class="m-rule">
        <div class="header"></div>
        <div class="list">
            <div class="item">
                <div>青年组评分标准</div>
                <div class="up" @click="go(1)">下载查看</div>
            </div>
            <div class="item">
                <div>壮年一组评分标准</div>
                <div class="up" @click="go(2)">下载查看</div>
            </div>
            <div class="item">
                <div>壮年二组评分标准</div>
                <div class="up" @click="go(3)">下载查看</div>
            </div>
            <div class="item">
                <div>老年组评分标准</div>
                <div class="up" @click="go(4)">下载查看</div>
            </div>
            <div class="item col">
                <div>线上达标赛活动规程</div>
                <div class="image">
                    <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20221028/1666953272/951287.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './index.less'
export default {
    data() {
        return {

        }
    },
    methods: {
        go(val) {
            switch(val) {
                case 1: 
                    window.location.href = "https://oss.mcloud.moveclub.cn/alphamovecloud/20221017/1665996378/361069.pdf"
                    return
                case 2: 
                    window.location.href = "https://oss.mcloud.moveclub.cn/alphamovecloud/20221017/1665996378/883004.pdf"
                    return
                case 3: 
                    window.location.href = "https://oss.mcloud.moveclub.cn/alphamovecloud/20221017/1665996378/161341.pdf"
                    return
                case 4: 
                    window.location.href = "https://oss.mcloud.moveclub.cn/alphamovecloud/20221017/1665996378/515109.pdf"
                    return
            }
        }
    },
    mounted() {

    }
}
</script>